(function () {
  try {
    /* main variables */
    var debug = 1;
    var variation_name = "cre-t-37";

    /* all Pure helper functions */
    // This is the cover product title list in the site
    var configCoverProduct = [
      { productHeaderText: "DIAMONDBACK HD" },
      { productHeaderText: "DIAMONDBACK SWITCHBACK" },
      { productHeaderText: "DIAMONDBACK SE" },
      { productHeaderText: "DIAMONDBACK 270" },
      { productHeaderText: "DIAMONDBACK 180" },
    ];

    function waitForElement(selector, trigger, delayInterval, delayTimeout) {
      delayInterval = delayInterval || 50;
      delayTimeout = delayTimeout || 15000;
      var interval = setInterval(function () {
        if (document && document.querySelector(selector) && document.querySelectorAll(selector).length > 0) {
          clearInterval(interval);
          trigger();
        }
      }, delayInterval);
      setTimeout(function () {
        clearInterval(interval);
      }, delayTimeout);
    }

    function forceInsertion(trigger, delayInterval, delayTimeout) {
      var interval = setInterval(function () {
        trigger();
      }, delayInterval);
      setTimeout(function () {
        clearInterval(interval);
      }, delayTimeout);
    }

    function live(selector, event, callback, context) {
      if (typeof callback !== "function") return;
      context = context || document;
      context.addEventListener(event, function (e) {
        var el = e.target.closest(selector);
        if (el && context.contains(el)) {
          callback.call(el, e);
        }
      });
    }

    function insertAfter(selector, html) {
      var element = typeof selector === "string" ? document.querySelector(selector) : selector;
      if (!element) return;
      if (typeof html === "string") {
        element.insertAdjacentHTML("afterend", html);
      } else if (html && html.nodeType === 1) {
        element.insertAdjacentElement("afterend", html);
      }
    }

    function insertBefore(selector, html) {
      var element = typeof selector === "string" ? document.querySelector(selector) : selector;
      if (!element) return;
      if (typeof html === "string") {
        element.insertAdjacentHTML("beforebegin", html);
      } else if (html && html.nodeType === 1) {
        element.insertAdjacentElement("beforebegin", html);
      }
    }

    /* Variation functions */
    function uspSection() {
      var uspSectionHtml = `
        <div class="cre-t-37-usp-container" style="display: none;">
          <div class="cre-t-37-usp-wrapper">
            <div class="cre-t-37-usp-content cre-t-37-usp-content1">
              <div class="cre-t-37-usp-image-parent">
                <div class="cre-t-37-usp-image">
                  <img src="https://v2.crocdn.com/Diamondbac-Covers/USPIconsUSA.svg" alt="usa icon" />
                </div>
              </div>
              <div class="cre-t-37-usp-title"><span>Built in the USA</span></div>
            </div>
            <div class="cre-t-37-usp-content cre-t-37-usp-content2">
              <div class="cre-t-37-usp-image-parent">
                <div class="cre-t-37-usp-image">
                  <img src="https://v2.crocdn.com/Diamondbac-Covers/USPIconsWarranty.svg" alt="warranty icon" />
                </div>
              </div>
              <div class="cre-t-37-usp-title"><span>Lifetime Warranty</span></div>
            </div>
            <div class="cre-t-37-usp-content cre-t-37-usp-content3">
              <div class="cre-t-37-usp-image-parent">
                <div class="cre-t-37-usp-image">
                  <img src="https://v2.crocdn.com/Diamondbac-Covers/USPIconFreeShipping.svg" alt="free shipping icon" />
                </div>
              </div>
              <div class="cre-t-37-usp-title"><span>Free Shipping</span></div>
            </div>
            <div class="cre-t-37-usp-content cre-t-37-usp-content4">
              <div class="cre-t-37-usp-image-parent">
                <div class="cre-t-37-usp-image">
                  <img src="https://v2.crocdn.com/Diamondbac-Covers/USPIcons30Day.svg" alt="30 day calendar icon" />
                </div>
              </div>
              <div class="cre-t-37-usp-title"><span>30 Day Returns</span></div>
            </div>
          </div>
        </div>
      `;

      waitForElement('body[data-path="/cart"] main#MainContent', function () {
        if (!document.querySelector(".cre-t-37-usp-container")) {
          insertBefore('body[data-path="/cart"] main#MainContent', uspSectionHtml);
        }
      });
    }

    function itemsInCartSection() {
      waitForElement('body[data-path="/cart"] h1.cart-title', function () {
        var itemsInCart = document.querySelector("span#CartCount").textContent.trim();
        if (itemsInCart) {
          var itemText = itemsInCart === "1" ? "item" : "items";
          var cardItemsHtml = `<div class="cre-t-37-total-items">(${itemsInCart} ${itemText})</div>`;
          if (!document.querySelector(".cre-t-37-total-items")) {
            insertAfter('body[data-path="/cart"] h1.cart-title', cardItemsHtml);
          }
        }
      });
    }

    function quantitySelector() {
      function syncRow(parent) {
        if (!parent) return;
        var oldInput = parent.querySelector(".cart__qty-input");
        if (!oldInput) return;
        parent.querySelectorAll(".cre-t-37-quantity-value").forEach(function (el) {
          el.textContent = oldInput.value;
        });
      }

      document.querySelectorAll("tr td .subtotal-cart").forEach(function (item) {
        var pricing = item.textContent.trim();
        var parent = item.closest("tr");
        if (!parent) return;
        var oldInput = parent.querySelector(".cart__qty-input");
        if (!oldInput) return;
        var warning = parent.querySelector(".fa.fa-exclamation-triangle");
        var warningParent = warning?.closest(".cart_cf").cloneNode(true);
        var pricingHtml = `
          ${warningParent ? `<div class="cre-t-37-warning-container">${warningParent.outerHTML}</div>` : ""}
          <div class="cre-t-37-subtotal-cart cre-t-37-subtotal-cart-mobile">
            <span>${pricing}</span>
          </div>
        `;
        var quantitySelectorHtml = `
          <div class="cre-t-37-item-pricing-container cre-t-37-item-pricing-desktop">
            <div class="cre-t-37-subtotal-cart">
              <span>${pricing}</span>
            </div>
            <div class="cre-t-37-quantity-container">
              <div class="cre-t-37-quantity-input">
                <div class="cre-t-37-quantity-decrease">-</div>
                <div class="cre-t-37-quantity-value"></div>
                <div class="cre-t-37-quantity-increase">+</div>
              </div>
            </div>
            <div class="cre-t-37-removeIcon">
              <span>Remove</span>
            </div>
          </div>
        `;
        var quantitySelectorHtml1 = `
          <div class="cre-t-37-item-pricing-container cre-t-37-item-pricing-mobile">
            <div class="cre-t-37-quantity-container">
              <div class="cre-t-37-quantity-input">
                <div class="cre-t-37-quantity-decrease">-</div>
                <div class="cre-t-37-quantity-value"></div>
                <div class="cre-t-37-quantity-increase">+</div>
              </div>
            </div>
            <div class="cre-t-37-removeIcon">
              <span>Remove</span>
            </div>
          </div>
        `;
        var immediateParent = item.parentElement;
        if (immediateParent && !immediateParent.querySelector(".cre-t-37-item-pricing-container")) {
          item.insertAdjacentHTML("afterend", quantitySelectorHtml);
        }
        var image = parent.querySelector(".cart__image-wrapper");
        if (image && !image.querySelector(".cre-t-37-item-pricing-container")) {
          image.insertAdjacentHTML("beforeend", quantitySelectorHtml1);
        }
        var title = parent.querySelector(".list-view-item__title");
        if (title && !title.querySelector(".cre-t-37-subtotal-cart-mobile")) {
          title.insertAdjacentHTML("beforeend", pricingHtml);
        }
        syncRow(parent);
      });

      if (!window.dbc37EventHandler1) {
        window.dbc37EventHandler1 = true;
        live(".cart__qty-input", "input", function () {
          var parent = this.closest("tr");
          syncRow(parent);
          document.body.classList.add("quantity-updated");
        });
        live(".cre-t-37-quantity-decrease", "click", function () {
          var parent = this.closest("tr");
          if (!parent) return;
          var oldInput = parent.querySelector(".cart__qty-input");
          if (!oldInput) return;
          var currentValue = parseInt(oldInput.value, 10);
          if (isNaN(currentValue)) currentValue = 0;
          var newValue = currentValue - 1;
          if (newValue < 0) newValue = 0;
          oldInput.value = newValue;
          syncRow(parent);
          document.body.classList.add("quantity-updated");
        });
        live(".cre-t-37-quantity-increase", "click", function () {
          var parent = this.closest("tr");
          if (!parent) return;
          var oldInput = parent.querySelector(".cart__qty-input");
          if (!oldInput) return;
          var currentValue = parseInt(oldInput.value, 10);
          if (isNaN(currentValue)) currentValue = 0;
          var newValue = currentValue + 1;
          oldInput.value = newValue;
          syncRow(parent);
          document.body.classList.add("quantity-updated");
        });
        live(".cre-t-37-removeIcon span", "click", function () {
          var parent = this.closest("tr");
          if (!parent) return;
          var removeButton = parent.querySelector(".delete-section .cart__remove.remove-btn");
          if (removeButton) {
            removeButton.click();
          }
        });
      }
    }

    function faqSection() {
      var faqHtml = `<div class="cre-t-37-faq-container" style="display: none">
        <div class="cre-t-37-faq-wrapper">
          <h2>Frequently Asked Questions</h2>
          <div class="cre-t-37-faq-item cre-t-37-faq-item-1 cre-t-37-faq-active">
            <div class="cre-t-37-faq-question">
              <strong>When will I get my order?</strong>
              <span class="cre-t-37-faq-toggle">${getToggleIcon()}</span>
            </div>
            <div class="cre-t-37-faq-answer cre-t-37-faq-answer-active">
              <p class="cre-t-37-faq-p">
                If you place your order today, it should leave our plant in Pennsylvania in 10-13 Days (or just 3 Business Days with a FastTrack Fee). Once it does, you'll receive a shipment notification email with tracking & an estimated delivery date. Transit time from PA varies from 1 to 7 business days, depending on your location.
              </p>
            </div>
          </div>
          <div class="cre-t-37-faq-item">
            <div class="cre-t-37-faq-question">
              <strong>How much is U.S. shipping?</strong>
              <span class="faq-toggle">${getToggleIcon()}</span>
            </div>
            <div class="cre-t-37-faq-answer">
              <p class="cre-t-37-faq-p">
                In the contiguous U.S., a DiamondBack cover or ATV/SXS Carrier ships free of charge. In AK & HI, a cover ships for $400. Orders that do not include a DiamondBack cover ship at a FedEx or UPS Ground rate calculated at checkout.
              </p>
            </div>
          </div>
          <div class="cre-t-37-faq-item">
            <div class="cre-t-37-faq-question">
              <strong>How much is Canadian & overseas shipping?</strong>
              <span class="cre-t-37-faq-toggle">${getToggleIcon()}</span>
            </div>
            <div class="cre-t-37-faq-answer">
              <p class="cre-t-37-faq-p">
                In ON, QC, & the Maritimes, a cover ships for US$100. And in the Prairie Provinces, Northern Canada, BC & NL, it's US$150. Orders that do not include a DiamondBack cover ship at a FedEx or UPS Ground rate calculated at checkout. Customers overseas should call (800.935.4002) or <a href="mailto:info@diamondbackcovers.com">email</a> for a quote.
              </p>
            </div>
          </div>
          <div class="cre-t-37-faq-item">
            <div class="cre-t-37-faq-question">
              <strong>How is sales tax determined for my order?</strong>
              <span class="cre-t-37-faq-toggle">${getToggleIcon()}</span>
            </div>
            <div class="cre-t-37-faq-answer">
              <p class="cre-t-37-faq-p">We are required to collect state, county & municipal sales tax for <a target="_blank" style="color:#0091B2" href="//diamondbackcovers.com/cdn/shop/files/Where_in_the_U.S._does_DiamondBack_collect_sales_tax.pdf?v=5959066209283362490"> these states</a>. We collect the 5% GST in Canada.</p>
            </div>
          </div>
          <div class="cre-t-37-faq-item">
            <div class="cre-t-37-faq-question">
              <strong>What payment methods can I use?</strong>
              <span class="cre-t-37-faq-toggle">${getToggleIcon()}</span>
            </div>
            <div class="cre-t-37-faq-answer">
              <div class="q-content">
                <p>We accept all major credit cards.</p>
                <p><img alt="Buy now with PayPal" src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/cc-badges-ppmcvdam.png"></p>
                <a class="affirm-site-modal" data-page-type="banner" aria-label="Affirm Financing Banner - Opens in Modal" style="cursor: pointer">
                  <img src="https://cdn-assets.affirm.com/images/banners/300x50.png" alt="Affirm Financing Banner"/>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>`;

      waitForElement(".cart tbody .cart__row", function () {
        if (!document.querySelector(".cre-t-37-faq-container")) {
          document.querySelector(".cart tbody").insertAdjacentHTML("beforeend", faqHtml);
        }
      });

      live(".cre-t-37-faq-question", "click", function (e) {
        e.preventDefault();
        var faqQuestion = e.target.closest(".cre-t-37-faq-question");
        var faqItem = faqQuestion.closest(".cre-t-37-faq-item");
        var faqAnswer = faqItem.querySelector(".cre-t-37-faq-answer");
        faqItem.classList.toggle("cre-t-37-faq-active");
        faqAnswer.classList.toggle("cre-t-37-faq-answer-active");
      });

      if (innerWidth < 992) {
        if (!document.querySelector(".cre-t-37-faq-container")) {
          insertAfter(".cart tbody", faqHtml);
        }
      }
    }

    function getToggleIcon() {
      return `
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M1.2707 5.07264L2.37546 3.95867L7.53738 9.07791L12.6566 3.91598L13.7706 5.02074L7.54659 11.2966L1.2707 5.07264Z" fill="#4F5150"/>
        </svg>
      `;
    }

    function orderSummary() {
      var Subtotal = document.querySelector(".cart__subtotal").textContent;
      var firstPrice = document.querySelector(".ft__price.laptop-and-below")?.textContent;
      var orderHtml = `<div class="cre-t-37-oder-container">
        <div class="cre-t-37-order-wrapper">
          <div class="cre-t-37-order-box">
            <div class="cre-t-37-order-content-head">
              <div class="cre-t-37-order-content-title">Order Summary</div>
            </div>
            <div class="cre-t-37-order-content-subtotal">
              <div class="cre-t-37-order-content-subtotal-title">Cart Subtotal</div>
              <div class="cre-t-37-order-content-subtotal-price">${Subtotal}</div>
            </div>
            <div class="cre-t-37-order-content-tax">
              <div class="cre-t-37-order-content-tax-title">Tax</div>
              <div class="cre-t-37-order-content-tax-price">Calculated at checkout</div>
            </div>
            <div class="cre-t-37-order-content-shipping">
              <div class="cre-t-37-order-content-shipping-content">
                <div class="cre-t-37-order-content-shipping-title">Shipping</div>
                <div class="cre-t-37-order-content-shipping-price-title">All covers ship free to contiguous USA</div>
              </div>
              <div class="cre-t-37-order-content-shipping-price">
                <div class="cre-t-37-order-content-shipping-price-value">$0</div>
                <div class="cre-t-37-order-content-shipping-price-text">Calculated at checkout</div>
              </div>
            </div>
            <div class="cre-t-37-order-content-total">
              <div class="cre-t-37-order-content-total-title">Subtotal</div>
              <div class="cre-t-37-order-content-total-price-container">
                <div class="cre-t-37-order-content-total-price-value">${Subtotal}</div>
                <div class="cre-t-37-order-content-total-price-text">
                  <div class="cre-t-37-total-price-wrapper">
                    <div class="cre-t-37-order-content-total-price-text-content">As low as <span class="cre-t-37-affirm-price"></span>/mo 0% APR with</div>
                    <div class="cre-t-37-order-content-total-price-text-content-img">
                      <img src="https://v2.crocdn.com/Diamondbac-Covers/affirm.png" alt="affirm" />
                    </div>
                  </div>
                  <div class="cre-t-37-order-content-total-price-link">Check your purchasing power</div>
                </div>
              </div>
            </div>
            <div class="cre-t-37-order-content-button">
              <div class="cre-t-37-order-update-button">Update</div>
              <div class="cre-t-37-order-checkout-button">Checkout</div>
            </div>
          </div>
          <div class="cre-t-37-test-box">
            <div class="cre-t-37-test-content">
              <div class="cre-t-37-test-content-img">
                <img src="https://v2.crocdn.com/Diamondbac-Covers/DB30DayTestDriveIcon1.png" alt="30-day returns" />
              </div>
              <div class="cre-t-37-test-content-subtitle">
                <div class="cre-t-37-test-content-subtitle-1">30-Day Returns, Dirt and All.</div>
                <div class="cre-t-37-test-content-subtitle-2">Test drive a DiamondBack and don't hold back. If you're not sold, return it. Shipping fees apply.</div>
              </div>
            </div>
          </div>
          <div class="cre-t-37-get-box ${firstPrice ? "orderHtml" : "orderHtmlHide"}">
            <div class="cre-t-37-get-head">
              <div class="cre-t-37-get-content-img">
                <img src="https://v2.crocdn.com/Diamondbac-Covers/test37/car.svg" alt="Get it faster" />
              </div>
              <div class="cre-t-37-get-content-subtitle">Get it Faster</div>
            </div>
            <div class="cre-t-37-get-content">
              <div class="cre-t-37-get-content-text">
                <div class="cre-t-37-get-content-text-1">
                  <div class="cre-t-37-get-content-text-fast">FastTrack Shipping</div>
                  <div class="cre-t-37-get-content-text-price">${firstPrice}</div>
                </div>
                <div class="cre-t-37-get-content-text-2">Ships in just <span>3 Business Days</span></div>
                <div class="cre-t-37-get-content-text-3">(Instead of 10-13 days)</div>
              </div>
            </div>
            <div class="cre-t-37-get-button">
              <div class="cre-t-get-button-cta">ADD FastTrack TO CART</div>
              <div class="cre-t-get-button-copy">*Non-refundable</div>
            </div>
          </div>
        </div>
      </div>`;

      if (!document.querySelector(".cre-t-37-oder-container")) {
        insertAfter(".cart tbody", orderHtml);
      }
    }

    function checkCoverProductInCart() {
      var cartTitles = Array.from(document.querySelectorAll(".cart .list-view-item__title a")).map(function (el) {
        return el.textContent.trim().toUpperCase();
      });
      var isFound = configCoverProduct.some(function (item) {
        var target = item.productHeaderText.trim().toUpperCase();
        return cartTitles.some(function (title) {
          return title.indexOf(target) !== -1;
        });
      });
      if (isFound) {
        document.body.classList.add("cre-t-37-found-cover");
        document.body.classList.remove("cre-t-37-not-found-cover");
      } else {
        document.body.classList.add("cre-t-37-not-found-cover");
        document.body.classList.remove("cre-t-37-found-cover");
      }
      console.log("Found cover product:", isFound);
      return isFound;
    }

    function eventListener() {
      live(".cre-t-37-order-checkout-button", "click", function () {
        document.querySelector('.cart-btn [name="checkout"]')?.click();
      });
      live(".cre-t-37-order-update-button", "click", function () {
        document.querySelector('.cart-btn [name="update"]')?.click();
      });
      live(".cre-t-get-button-cta", "click", function () {
        document.querySelector("#atc--fasttrack-btn")?.click();
      });
      live(".cre-t-37-cart-content-cta", "click", function () {
        document.querySelector('.cart-btn [name="checkout"]')?.click();
      });
    }

    function forMob() {
      var SubtotalMob = document.querySelector(".cart__subtotal").textContent;
      var html = `<div class="cre-t-37-mobile-cart">
        <div class="cre-t-37-mobile-cart-wrapper">
          <div class="cre-t-37-cart-content">Cart Total</div>
          <div class="cre-t-37-cart-content-value">${SubtotalMob}</div>
        </div>
        <div class="cre-t-37-cart-content-cta">Continue to Checkout</div>
      </div>`;
      if (!document.querySelector(".cre-t-37-mobile-cart")) {
        document.querySelector(".section-header").insertAdjacentHTML("afterend", html);
      }
    }

    function replaceImageSrcWithTestImage() {
      const images = document.querySelectorAll(".cart__image");
      images.forEach((image) => {
        const testImage = image.getAttribute("data-testimage");
        if (testImage) {
          image.setAttribute("src", testImage);
        }
      });
    }

    // Only activate when the AB platform has added body.cre-t-37.
    // Use a MutationObserver to handle cases where the class is added after this script runs.
    function startVariation() {
      // Phase 1: trigger on cart DOM ready — no Affirm dependency.
      // Structural changes happen immediately so there's no visible stepped reveal.
      waitForElement(".cart tbody .cart__row", function () {
        if (document.body.dataset.cret37Init) return;
        document.body.dataset.cret37Init = "1";

        const sectionHeader = document.querySelector(".section-header");
        const cartTbody = document.querySelector(".cart tbody");
        cartTbody.insertBefore(sectionHeader, cartTbody.firstChild);
        live(".cre-t-37-order-content-total-price-link", "click", function () {
          document.querySelector(".cart_sub .affirm-as-low-as .affirm-modal-trigger").click();
        });
        uspSection();
        itemsInCartSection();
        faqSection();
        checkCoverProductInCart();
        orderSummary();
        replaceImageSrcWithTestImage();
        forMob();
        forceInsertion(
          function () {
            quantitySelector();
          },
          100,
          3000,
        );
        eventListener();

        // Populate the Affirm price in the already-rendered sidebar once it's available.
        waitForElement(".cart_sub .affirm-ala-price", function () {
          var priceEl = document.querySelector(".cre-t-37-affirm-price");
          var affirmSection = document.querySelector(".cre-t-37-order-content-total-price-text");
          var alaPrice = document.querySelector(".cart_sub .affirm-ala-price")?.textContent;
          if (priceEl && alaPrice) priceEl.textContent = alaPrice;
          if (affirmSection) affirmSection.style.opacity = "1";
        });
      });
    }

    if (document.body.classList.contains(variation_name)) {
      startVariation();
    } else {
      var classObserver = new MutationObserver(function () {
        if (document.body.classList.contains(variation_name)) {
          classObserver.disconnect();
          startVariation();
        }
      });
      classObserver.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    }
  } catch (e) {
    if (debug) console.log(e, "error in Test " + variation_name);
  }
})();
